import RebateTnc from '../pages/Setting/RebateTnc';

const RebateTncRoutes = [
  {
    breadcrumb: [{ path: '/setting/rebate-tnc', breadcrumbName: 'Rebate TNC' }],
    Component: RebateTnc,
  }
];

export default RebateTncRoutes;